import Hook from "./useCard";
import qbo_logo from "../../../assets/qbo_logo.svg";
import { PrimaryButton } from "@moneris-portal/button";

const QBO_Card = () => {
  const { translate, lang, history } = Hook.useCard();
  return (
    <div className="application_card_container">
      <div className="application_card_body">
        <div className={`cardIcon`}>
          <img src={qbo_logo} alt="Quickbooks logo" />
        </div>
        <div className="card_desc">
          <div className="cardTitle">
            <span>{translate("card-title")}</span>
          </div>
          <div className="cardDesc">
            <span>
              <strong>{translate("card-description-bold")}</strong>
            </span>
          </div>
          <div className="cardDesc">
            <span>{translate("card-description")}</span>
          </div>
          <div className="_card_buttons">
            <PrimaryButton
              title={translate("card-button")}
              clickHandler={() => history.push(`/${lang}/qbo-accounting`)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QBO_Card;

